import type { ReactNode } from 'react';
import Skeleton, { type SkeletonProps } from 'react-loading-skeleton';

export type SkeletonLoaderProps = {
  loading?: boolean;
  children?: ReactNode;
} & SkeletonProps;

export const SkeletonLoader = ({ loading, children, ...rest }: SkeletonLoaderProps) => (
  <>{loading ? <Skeleton {...rest} /> : children}</>
);
